var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDistributionSpot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 56,
    viewBox: "0 0 142 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spot",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#894bf6",
    stopOpacity: "{0}"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ca4bf6",
    stopOpacity: "{1}"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 26.5,
    y: 40,
    width: 9,
    height: 8,
    rx: 2,
    fill: "url(#spot)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 36.5,
    y: 40,
    width: 9,
    height: 8,
    rx: 2,
    fill: "url(#spot)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 46.5,
    y: 40,
    width: 9,
    height: 8,
    rx: 2,
    fill: "url(#spot)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 8,
    width: 9,
    height: 40,
    rx: 2,
    fill: "url(#spot)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 8,
    width: 9,
    height: 40,
    rx: 2,
    fill: "url(#spot)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 8,
    width: 9,
    height: 40,
    rx: 2,
    fill: "url(#spot)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 86.5,
    y: 40,
    width: 9,
    height: 8,
    rx: 2,
    fill: "url(#spot)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 96.5,
    y: 40,
    width: 9,
    height: 8,
    rx: 2,
    fill: "url(#spot)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 106.5,
    y: 40,
    width: 9,
    height: 8,
    rx: 2,
    fill: "url(#spot)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributionSpot);
export default __webpack_public_path__ + "static/media/distribution_spot.de1031651ee7eadb7b1a8f311b94e5b3.svg";
export { ForwardRef as ReactComponent };